module.exports = {
    ACTIVE: 'active',
    PENDING: 'pending'
};
